import * as React from "react";
const SvgFiRrVolcano = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-volcano_svg__a)">
      <path
        fill="#062147"
        d="M20.876 24H3.124a3.122 3.122 0 0 1-2.4-5.118L8.87 10.31A1 1 0 0 1 9.6 10h4.8a1 1 0 0 1 .724.31l8.1 8.523A3.12 3.12 0 0 1 20.876 24M6.224 16l-4 4.21a1.132 1.132 0 0 0 .9 1.79h17.752a1.125 1.125 0 0 0 .86-1.837L17.775 16H16a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0v-3a1 1 0 1 0-2 0v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1zm5.775-2c.739 0 1.451.272 2 .766A3 3 0 0 1 15.878 14l-1.9-2h-3.952l-1.9 2c.695.03 1.358.3 1.875.766A3 3 0 0 1 12 14m7-5c-.48 0-.954-.118-1.38-.342A4 4 0 0 1 16 9h-2a1 1 0 1 1 0-2h2c.398 0 .787-.118 1.117-.34a1 1 0 0 1 1.224.082A.992.992 0 1 0 19 5a1.11 1.11 0 0 1-1.122-.653A1.99 1.99 0 0 0 15.02 3.27a1 1 0 0 1-1.337-.335 2 2 0 0 0-3.37 0 1 1 0 0 1-1.335.335 1.99 1.99 0 0 0-2.857 1.077 1.015 1.015 0 0 1-1.034.667L4.977 5a.991.991 0 1 0 .683 1.74 1 1 0 0 1 1.224-.08c.33.222.718.34 1.116.34h2a1 1 0 0 1 0 2H8c-.558 0-1.11-.116-1.62-.342C2.165 10.568.029 4 4.527 3.037A3.99 3.99 0 0 1 9.169 1.18a4.01 4.01 0 0 1 5.662 0 3.99 3.99 0 0 1 4.642 1.856A3 3 0 0 1 19 9"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-volcano_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolcano;
